const TABBABLE = [
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  '[href]',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/**
 * `onOpenAutoFocus` for a Radix Dialog whose header holds a Close button:
 * start in the body's first field or control (Figma: Modal "Content swapped
 * to Field (focused)") instead of on Close. Falls back to Radix's default -
 * the first tabbable, usually Close - when the body has none.
 */
export function focusBodyFirst(event: Event, bodySlot: string) {
  const content = event.target as HTMLElement | null;
  const target = content
    ?.querySelector(`[data-slot="${bodySlot}"]`)
    ?.querySelector<HTMLElement>(TABBABLE);
  if (target) {
    event.preventDefault();
    target.focus();
  }
}
